/**
 * results selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectResults = state => state.results;

const makeSelectResult = namespace =>
    createDeepEqualSelector(
        selectResults,
        resultsState => resultsState[namespace]
    );

export { makeSelectResult };
